import { Collapse, Descriptions, Drawer } from "antd";
import styled from "styled-components";

export const StyledDescriptions = styled(Descriptions)`
  th,
  td {
    padding: 5px !important;
  }
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
  .ant-descriptions-item-label {
    width: 200px;
  }
`;

export const StyledXAICallBody = styled.div`
  padding: 20px;
`;

export const StyledXAICallFooter = styled.div`
  background: ${({ theme }: any) =>
    theme.palette.background.default} !important;
  padding: 0 20px 30px 20px;
  border-top: 1px solid ${({ theme }: any) => theme.palette.primary.main} !important;
`;

export const AudioPlayerContainer = styled.div`
  margin: 16px 0;
  padding: 16px;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
`;

export const ConversationAnalysis = styled.div`
  margin: 16px 0;
  padding: 16px;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
`;

export const SummarySection = styled.div`
  margin: 16px 0;
  padding: 16px;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
  white-space: pre-wrap;
`;

export const StyledAudio = styled.audio`
  width: 100%;
  margin-top: 8px;
`;

export const StyledXAICallLogItem = styled.div``;

export const StyledCollapse = styled(Collapse)`
  background: transparent;
  border-radius: ${({ theme }) => theme.cardRadius};
  border: 1px dashed ${({ theme }) => theme.palette.borderColor};
`;
